export var deg2rad = Math.PI / 180;
export var rad2deg = 180 / Math.PI;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-color@1.4.0@d3-color/src/math.js
// module id = 121
// module chunks = 0 1 2